export const CACHE_KEY = {
  GNB: {
    GNB_INFO: 'GNB_INFO',
  },
  LNB: {
    LNB_INFO: 'LNB_INFO',
  },
  MAIN: {
    MAIN_DISPLAY: 'MAIN_DISPLAY',
  },
  LIVE: {
    LIVE_MAIN: 'LIVE_MAIN',
    LIVE_COMING: 'LIVE_COMING',
    LIVE_REPLAY: 'LIVE_REPLAY',
  },
  BEST: {
    BEST_CATEGORY: 'BEST_CATEGORY',
    BEST_PRODUCTS: 'BEST_PRODUCTS',
    BEST_PRODUCTS_VOD: 'BEST_PRODUCTS_VOD',
    BEST_MOLOCO_AD_LP_PRODUCTS: 'BEST_MOLOCO_AD_LP_PRODUCTS',
  },
  FORYOU: {
    FORYOU_PRODUCTS: 'FORYOU_PRODUCTS',
    STYLE_FORYOU_PRODUCTS: 'STYLE_FORYOU_PRODUCTS',
  },
  SEARCH: {
    SEARCH_PRODUCTS: 'SEARCH_PRODUCTS',
    SEARCH_REVIEW: 'SEARCH_REVIEW',
    SEARCH_EVENT: 'SEARCH_EVENT',
    SEARCH_PRODUCTS_STATUS: 'SEARCH_PRODUCTS_STATUS',
    SEARCH_INIT_POPULAR_KEYWORD: 'SEARCH_INIT_POPULAR_KEYWORD',
    SEARCH_INIT_RECO_KEYWORD: 'SEARCH_INIT_RECO_KEYWORD',
    SEARCH_INIT_STYLE_CLIP: 'SEARCH_INIT_STYLE_CLIP',
    SEARCH_INIT_ONBOARDING_AGENT: 'SEARCH_INIT_ONBOARDING_AGENT',
    SEARCH_INIT_SEARCHINPUT_KEYWORD: 'SEARCH_INIT_SEARCHINPUT_KEYWORD',
  },
  PROMOTION: {
    PROMOTION_DISPLAY: 'PROMOTION_DISPLAY',
    PROMOTION_PRODUCTS: 'PROMOTION_PRODUCTS',
    PROMOTION_PRODUCTS_STATUS: 'PROMOTION_PRODUCTS_STATUS',
  },
  CATEGORY: {
    CATEGORY_DISPLAY: 'CATEGORY_DISPLAY',
    CATEGORY_DISPLAY_DETAIL: 'CATEGORY_DISPLAY_DETAIL',
    CATEGORY_MAIN_KEYS: 'CATEGORY_MAIN_KEYS',
    CATEGORY_PRODUCTS: 'CATEGORY_PRODUCTS',
    CATEGORY_PRODUCTS_STATUS: 'CATEGORY_PRODUCTS_STATUS',
    CATEGORY_MOLOCO_AD_LP_PRODUCTS: 'CATEGORY_MOLOCO_AD_LP_PRODUCTS',
    CATEGORY_MOLOCO_SIMILAR: 'CATEGORY_MOLOCO_SIMILAR',
    CATEGORY_MOLOCO_RECOMMEND: 'CATEGORY_MOLOCO_RECOMMEND',
  },
  CATEGORY_CORNER: {
    CATEGORY_CORNER_DISPLAY: 'CATEGORY_CORNER_DISPLAY',
    CATEGORY_CORNER_DISPLAY_DETAIL: 'CATEGORY_CORNER_DISPLAY_DETAIL',
  },
  BRAND: {
    BRAND_MYHEART: 'BRAND_MYHEART',
    BRAND_DISPLAY: 'BRAND_DISPLAY',
    BRAND_PRODUCTS: 'BRAND_PRODUCTS',
    BRAND_PRODUCTS_STATUS: 'BRAND_PRODUCTS_STATUS',
    BRAND_PRESHOW: 'BRAND_PRESHOW',
    BRAND_COUNT: 'BRAND_COUNT',
  },
  LOOKBOOK: {
    LOOKBOOK_DISPLAY: 'LOOKBOOK_DISPLAY',
  },
  NEW: {
    NEW_DISPLAY: 'NEW_DISPLAY',
    NEW_PRODUCTS: 'NEW_PRODUCTS',
    NEW_PRODUCTS_STATUS: 'NEW_PRODUCTS_STATUS',
    NEW_MOLOCO_AD: 'NEW_MOLOCO_AD',
  },
  SPECIALTY: {
    SPECIALTY_DISPLAY: 'SPECIALTY_DISPLAY',
    SPECIALTY_PRODUCTS: 'SPECIALTY_PRODUCTS',
    SPECIALTY_LAUNCHES: 'SPECIALTY_LAUNCHES',
    SPECIALTY_PRODUCTS_STATUS: 'SPECIALTY_PRODUCTS_STATUS',
  },
  SPC: {
    SPC_DISPLAY: 'SPC_DISPLAY',
    SPC_PRODUCTS: 'SPC_PRODUCTS',
    SPC_NAVIGATION: 'SPC_NAVIGATION',
  },
  ALLY: {
    ALLY_DISPLAY: 'ALLY_DISPLAY',
  },
  SALE: {
    SALE_DISPLAY: 'SALE_DISPLAY',
    SALE_PRODUCTS: 'SALE_PRODUCTS',
    SALE_PRODUCTS_STATUS: 'SALE_PRODUCTS_STATUS',
    SALE_MOLOCO_AD: 'SALE_MOLOCO_AD',
    SALE_MOLOCO_AD_LP_PRODUCTS: 'SALE_MOLOCO_AD_LP_PRODUCTS',
  },
  TIMEDEAL: {
    TIMEDEAL_PRODUCTS: 'TIMEDEAL_PRODUCTS',
  },
  HISTORY: {
    HISTORY_PRODUCTS: 'HISTORY_PRODUCTS',
    HISTORY_BEST_PRODUCTS: 'HISTORY_BEST_PRODUCTS',
    HISTORY_RECOMMEND_STYLE_CLIP: 'HISTORY_RECOMMEND_STYLE_CLIP',
    HISTORY_MOLOCO_AD: 'HISTORY_MOLOCO_AD',
  },
  EXCLUSIVE: {
    EXCLUSIVE_DISPLAY: 'EXCLUSIVE_DISPLAY',
    EXCLUSIVE_PRODUCTS: 'EXCLUSIVE_PRODUCTS',
    EXCLUSIVE_PRODUCTS_STATUS: 'EXCLUSIVE_PRODUCTS_STATUS',
    EXCLUSIVE_BRANDS: 'EXCLUSIVE_BRANDS',
  },
  DESIGNER: {
    DESIGNER_BRAND_LIST: 'DESIGNER_BRAND_LIST',
    DESIGNER_RECOMMEND_BRAND_LIST: 'DESIGNER_RECOMMEND_BRAND_LIST',
  },
  PRESHOW: {
    PRESHOW_DISPLAY: 'PRESHOW_DISPLAY',
    PRESHOW_TABMENU: 'PRESHOW_TABMENU',
    PRESHOW_PRODUCTS: 'PRESHOW_PRODUCTS',
  },
  COUPON: {
    COUPON_PRODUCTS: 'COUPON_PRODUCTS',
  },
  WLABEL: {
    WLABEL_DISPLAY: 'WLABEL_DISPLAY',
  },
  DISCOVERY: {
    DISCOVERY_LIST: 'DISCOVERY_LIST',
    DISCOVERY_SHORTFORM: 'DISCOVERY_SHORTFORM',
    DISCOVERY_MOLOCO_AD: 'DISCOVERY_MOLOCO_AD',
  },
  STYLECLIP: {
    STYLECLIP_FILTER: 'STYLECLIP_FILTER',
    STYLECLIP_MAIN: 'STYLECLIP_MAIN',
    STYLECLIP_SHORTFORM: 'STYLECLIP_SHORTFORM',
    STYLECLIP_SHORTFORM_BY_PROFILE: 'STYLECLIP_SHORTFORM_BY_PROFILE',
    STYLECLIP_SHORTFORM_RANKING: 'STYLECLIP_SHORTFORM_RANKING',
    STYLECLIP_SHORTFORM_FOLLOWING: 'STYLECLIP_SHORTFORM_FOLLOWING',
    STYLECLIP_CREATE_KEYWORD: 'STYLECLIP_CREATE_KEYWORD',
    STYLECLIP_USER_TAB_CONTENT: 'STYLECLIP_USER_TAB_CONTENT',
    STYLECLIP_USER_TAB_MYHEART: 'STYLECLIP_USER_TAB_MYHEART',
    STYLECLIP_USER_TAB_PRODUCT: 'STYLECLIP_USER_TAB_PRODUCT',
    STYLECLIP_RECOMMEND: 'STYLECLIP_RECOMMEND',
    STYLECLIP_RECOMMEND_TAB: 'STYLECLIP_RECOMMEND_TAB',
    STYLECLIP_RECOMMEND_FEED: 'STYLECLIP_RECOMMEND_FEED',
    STYLECLIP_RECOMMEND_CREATOR_LIST: 'STYLECLIP_RECOMMEND_CREATOR_LIST',
    STYLECLIP_RANKING_CATEGORY: 'STYLECLIP_RANKING_CATEGORY',
    STYLECLIP_RANKING_STYLING_STYLECLIP_LIST:
      'STYLECLIP_RANKING_STYLING_STYLECLIP_LIST',
    STYLECLIP_RANKING_CUSTOMER_STYLECLIP_LIST:
      'STYLECLIP_RANKING_CUSTOMER_STYLECLIP_LIST',
    STYLECLIP_RANKING_BRAND_STYLECLIP_LIST:
      'STYLECLIP_RANKING_BRAND_STYLECLIP_LIST',
    STYLECLIP_LP_CONTENT: 'STYLECLIP_LP_CONTENT',
    STYLECLIP_FOLLOW_LIST: 'STYLECLIP_FOLLOW_LIST',
    STYLECLIP_FOLLOW_FEED: 'STYLECLIP_FOLLOW_FEED',
    STYLECLIP_FOLLOW_FEED_RECOMMEND: 'STYLECLIP_FOLLOW_FEED_RECOMMEND',
    STYLECLIP_FOLLOW_FEED_PRODUCT_INFO: 'STYLECLIP_FOLLOW_FEED_PRODUCT_INFO',
    STYLECLIP_FOLLOW_FEED_HAS_NEW: 'STYLECLIP_FOLLOW_FEED_HAS_NEW',
    STYLECLIP_PROFILE_HIDE_LIST: 'STYLECLIP_PROFILE_HIDE_LIST',
  },
  KERYWORD: {
    KEYWORD_PRODUCT_TAB: 'KEYWORD_PRODUCT_TAB',
    KEYWORD_CONTENT_TAB: 'KEYWORD_CONTENT_TAB',
  },
  MYHEART: {
    PRODUCT_TAB_LIST: 'PRODUCT_TAB_LIST',
    PRODUCT_LIST: 'PRODUCT_LIST',
    PRODUCT_POPULAR_LIST: 'PRODUCT_POPULAR_LIST',
    PRODUCT_RELATED_LIST: '',
    COLLECTION_LIST: 'COLLECTION_LIST',
    COLLECTION_PRODUCT_LIST: 'COLLECTION_PRODUCT_LIST',
    BRAND_LIST: 'BRAND_LIST',
    BRAND_POPULAR_LIST: 'BRAND_POPULAR_LIST',
    BRAND_RELATED_LIST: 'BRAND_RELATED_LIST',
    CONTENTS_TAB_LIST: 'CONTENTS_TAB_LIST',
    CONTENTS_LIST: 'CONTENTS_LIST',
    CONTENTS_POPULAR_LIST: 'CONTENTS_POPULAR_LIST',
    CONTENTS_RELATED_LIST: 'CONTENTS_RELATED_LIST',
    PRODUCT_MOLOCO_AD: 'PRODUCT_MOLOCO_AD',
  },
  SMART_BANNER: {
    SMART_BANNER_DATA: 'SMART_BANNER_DATA',
  },
};
